import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { Container, Header, Recipe, RecipeIcon, RecipeTitle } from './RecipeBlock.style';

var RecipeBlock = function RecipeBlock(_ref) {
  var block = _ref.block,
      editorState = _ref.blockProps.editorState;

  var _useState = useState(''),
      recipeId = _useState[0],
      setRecipeId = _useState[1];

  var _useState2 = useState(true),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var _useGetBlockData = useGetBlockData(editorState, block.getKey(), block.getEntityAt(0)),
      blockData = _useGetBlockData.blockData,
      entityData = _useGetBlockData.entityData;

  useEffect(function () {
    setOpenModal(blockData.openModal);
    setRecipeId(entityData.recipeId);
  }, [blockData, entityData]);
  return __jsx(Container, null, __jsx(Header, {
    contentEditable: false
  }, __jsx(RecipeIcon, null), __jsx(RecipeTitle, null, __jsx(FormattedMessage, {
    id: "recipe-modal.recipeIdField"
  }))), (recipeId || !openModal) && __jsx(Recipe, null, recipeId));
};

export default RecipeBlock;